import(/* webpackMode: "eager" */ "/codebuild/output/src3544664266/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/not-found.tsx");
